/* ORGAINIC Partner Hub — section "partner-hub" */
(function(){
'use strict';

let root = null;
let CFG = {};
let CARD_BG = {};
let ICON_B64 = null;
let WORD_B64 = null;
const JSPDF_URL = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';

function pad(n, len){ n = String(n); while(n.length < len){ n = '0'+n; } return n; }
function esc(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }

const SECTIONS = {
  b2b: {
    refPrefix: 'ORG-B2B',
    label: 'B2B & Handel',
    cardDesc: 'Einzelhandel, Studios, Online-Shops, Großhandel: Ihr wollt ORGAINIC führen oder vertreiben.',
    subtitle: 'B2B-Anfrage',
    refNote: 'Eure Angaben gehen an unser Vertriebsteam',
    chapters: [
      {id:'unternehmen', title:'Unternehmen', desc:'Wer ihr seid'},
      {id:'geschaeftsmodell', title:'Geschäftsmodell', desc:'Womit ihr handelt'},
      {id:'zusammenarbeit', title:'Zusammenarbeit', desc:'Was euch vorschwebt'},
      {id:'markt', title:'Markt & Volumen', desc:'Zahlen zur Einordnung'},
      {id:'hintergrund', title:'Hintergrund', desc:'Der letzte Kontext'},
      {id:'summary', title:'Zusammenfassung', desc:'Anfrage absenden'}
    ],
    options: {
      businessType: ['Einzelhandel / Fachgeschäft','Fitnessstudio / Gym','Online-Shop / E-Commerce','Großhandel / Distribution','Gastronomie / Café','Sonstige'],
      cooperationType: ['Listung im Sortiment','Exklusivvertrieb für eine Region','Großhandelsbelieferung','White-Label / Eigenmarke','Cross-Promotion / Co-Marketing','Sonstige'],
      productInterest: ['Riegel','Proteinpulver','Kapseln & Tabletten','Trinkfertig / Shot','Superfood / Sonstiges']
    },
    defaultData: {
      companyName:'', contactName:'', email:'', role:'', website:'',
      businessType:'', locationsCount:'', customerBase:'',
      cooperationType:[], productInterest:[],
      region:'', estimatedVolume:'', deliveryRhythm:'',
      currentBrands:'', whyOrgainic:''
    }
  },
  creator: {
    refPrefix: 'ORG-CR',
    label: 'Creator & UGC',
    cardDesc: 'Du machst Content wie Reels, Stories oder YouTube und willst mit ORGAINIC zusammenarbeiten.',
    subtitle: 'Creator & Affiliate Bewerbung',
    refNote: 'Deine Angaben bleiben bei uns',
    chapters: [
      {id:'ueberdich', title:'Über dich', desc:'Wer du bist'},
      {id:'positionierung', title:'Sportart & Content', desc:'Wofür du stehst'},
      {id:'reichweite', title:'Reichweite & Kanäle', desc:'Wo du unterwegs bist'},
      {id:'umfang', title:'Content-Umfang', desc:'Was du dir vorstellst'},
      {id:'rechte', title:'Rechte & Sonstiges', desc:'Die letzten Details'},
      {id:'summary', title:'Zusammenfassung', desc:'Dein Steckbrief'}
    ],
    options: {
      sportFocus: ['Ausdauersport','Kraft- & Fitnesssport','Longevity & Gesundheit','Ernährung & Rezepte','Functional Training / Calisthenics','Reha & Prävention','Lifestyle & Alltag','Sonstige'],
      contentFormats: ['Reels & Shorts','Stories','Feed-Posts','YouTube / Long-form','Unboxing & Reviews','Trainings-Content','Rezept-Content','Sonstige'],
      platforms: ['Instagram','TikTok','YouTube','Sonstige'],
      audienceSize: ['Nano (bis 10k)','Micro (10k bis 50k)','Mid (50k bis 200k)','Makro (200k+)'],
      usageRights: ['Nur organisch auf meinem Profil','Auch für Ads / Whitelisting','Verhandelbar']
    },
    defaultData: {
      name:'', email:'', qualification:'', whyOrgainic:'',
      sportFocus:[], contentFormats:[], blank1:'', blank2:'', blank3:'',
      platforms:[], audienceSize:'', handles:'', audienceDescription:'',
      plannedVolume:'', availability:'', pastCollabs:'',
      usageRights:'', portfolio:'', notes:''
    }
  },
  athlete: {
    refPrefix: 'ORG-AT',
    label: 'Sportler & Athleten',
    cardDesc: 'Du trittst wettkampfmäßig an und suchst Unterstützung durch ORGAINIC.',
    subtitle: 'Athleten-Bewerbung',
    refNote: 'Deine Angaben bleiben bei uns',
    chapters: [
      {id:'ueberdich', title:'Über dich', desc:'Wer du bist'},
      {id:'leistung', title:'Leistungsniveau', desc:'Wo du stehst'},
      {id:'saison', title:'Wettkampfkalender', desc:'Deine Saison'},
      {id:'positionierung', title:'Positionierung', desc:'Wofür du stehst'},
      {id:'sichtbarkeit', title:'Sichtbarkeit', desc:'Reichweite & Medien'},
      {id:'unterstuetzung', title:'Unterstützung', desc:'Was du dir vorstellst'},
      {id:'summary', title:'Zusammenfassung', desc:'Dein Steckbrief'}
    ],
    options: {
      sportart: ['Ausdauersport (Laufen / Rad / Triathlon)','Kraft- & Kraftsport','Mannschaftssport','Kampfsport','Wintersport','Sonstige'],
      level: ['Freizeit / Amateur','Ambitionierter Amateur','Regional- / Landesliga','National','International / Profi'],
      values: ['Ausdauer','Kraft','Longevity & Gesundheit','Ernährung','Teamgeist','Sonstige'],
      platforms: ['Instagram','TikTok','YouTube','Sonstige'],
      supportType: ['Produkt zur Wettkampfvorbereitung','Ausrüstungs- / Trikot-Branding','Präsenz bei Events','Content-Zusammenarbeit','Sonstige']
    },
    defaultData: {
      name:'', email:'', sportart:'', club:'', coach:'',
      level:'', achievements:'', license:'',
      keyEvents:'', trainingLoad:'', seasonGoal:'',
      values:[], blank1:'', blank2:'', blank3:'',
      platforms:[], handles:'', mediaPresence:'', currentSponsors:'',
      supportType:[], availability:''
    }
  },
  affiliate: {
    refPrefix: 'ORG-AFF',
    label: 'Affiliates',
    cardDesc: 'Du empfiehlst Produkte über Newsletter, Podcast oder Kundenstamm, ohne eigene Content-Produktion.',
    subtitle: 'Affiliate-Bewerbung',
    refNote: 'Deine Angaben bleiben bei uns',
    chapters: [
      {id:'ueberdich', title:'Über dich', desc:'Deine Plattform'},
      {id:'reichweite', title:'Reichweite', desc:'Wie viele Menschen'},
      {id:'empfehlung', title:'Wie du empfiehlst', desc:'Format & Frequenz'},
      {id:'erfahrung', title:'Erfahrung', desc:'Was du schon kennst'},
      {id:'summary', title:'Zusammenfassung', desc:'Dein Steckbrief'}
    ],
    options: {
      platformType: ['Newsletter','Podcast','Blog / Website','Community / Forum','Trainer-/Coaching-Kundenstamm','Sonstige'],
      audienceSize: ['bis 1.000','1.000 bis 10.000','10.000 bis 50.000','50.000+'],
      formats: ['Rabattcode','Trackinglink','Redaktioneller Beitrag / Review','Persönliche Empfehlung im Gespräch','Sonstige'],
      trackingExperience: ['Ja, kenne ich schon','Nein, wäre neu für mich']
    },
    defaultData: {
      name:'', email:'', platformType:'', platformLink:'',
      audienceSize:'', audienceDescription:'',
      formats:[], frequency:'',
      pastPartnerships:'', trackingExperience:''
    }
  }
};

const state = { section:null, step:0, data:{}, ref:'' };

/* Pflichtangaben je Kategorie, gruppiert nach Kapitel-ID */
const REQUIRED = {
  b2b:       { unternehmen:['companyName','contactName','email'], geschaeftsmodell:['businessType'], zusammenarbeit:['cooperationType'] },
  creator:   { ueberdich:['name','email'], reichweite:['platforms','audienceSize','handles'] },
  athlete:   { ueberdich:['name','email','sportart'], leistung:['level'], unterstuetzung:['supportType'] },
  affiliate: { ueberdich:['name','email','platformType','platformLink'], reichweite:['audienceSize'] }
};
const REQUIRED_LABELS = {
  companyName:'Firmenname', contactName:'Ansprechpartner:in', email:'E-Mail', businessType:'Art des Geschäfts',
  cooperationType:'Kooperationsform', name:'Name', platforms:'Plattformen', audienceSize:'Größenordnung der Reichweite',
  handles:'Handles', sportart:'Sportart', level:'Wettkampfklasse', supportType:'Gewünschte Unterstützung',
  platformType:'Art der Plattform', platformLink:'Link zur Plattform'
};
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function requiredFor(chapterId){ return (REQUIRED[state.section]||{})[chapterId] || []; }
function isRequired(field){
  const r = REQUIRED[state.section] || {};
  return Object.keys(r).some(k=>r[k].includes(field));
}
function fieldError(field){
  const v = state.data[field];
  const empty = Array.isArray(v) ? v.length===0 : !String(v||'').trim();
  if(empty) return field==='email' ? 'Bitte gib deine E-Mail-Adresse an.' : 'Pflichtangabe';
  if(field==='email' && !EMAIL_RE.test(String(v).trim())) return 'Bitte gib eine gültige E-Mail-Adresse an.';
  return '';
}
function missingIn(chapterId){ return requiredFor(chapterId).filter(f=>fieldError(f)); }
function allMissing(){
  const sec = SECTIONS[state.section];
  const out = [];
  sec.chapters.forEach((c,i)=>missingIn(c.id).forEach(f=>out.push({field:f, step:i})));
  return out;
}
function reqMark(field){ return isRequired(field) ? ' <span class="oph-req" aria-hidden="true">*</span>' : ''; }
function markInvalid(fields){
  const main = document.getElementById('oph-main');
  fields.forEach(f=>{
    const block = main.querySelector('[data-field="'+f+'"]');
    if(!block) return;
    block.classList.add('oph-invalid');
    const err = block.querySelector('.oph-field-error');
    if(err) err.textContent = fieldError(f);
  });
  const first = main.querySelector('.oph-invalid');
  if(first){
    first.scrollIntoView({behavior:'smooth', block:'center'});
    const inp = first.querySelector('input, textarea');
    if(inp) inp.focus({preventScroll:true});
  }
}
function clearInvalid(field){
  const block = document.querySelector('#oph-main [data-field="'+field+'"]');
  if(block && block.classList.contains('oph-invalid') && !fieldError(field)) block.classList.remove('oph-invalid');
}

function genRef(prefix){
  const d = new Date();
  const ymd = d.getFullYear().toString() + pad(d.getMonth()+1,2) + pad(d.getDate(),2);
  const hex = pad(Math.floor(Math.random()*0xFFFF).toString(16).toUpperCase(), 4);
  return prefix+'-'+ymd+'-'+hex;
}

function tile(field, value, mode){
  const arr = state.data[field];
  const active = mode==='multi' ? arr.includes(value) : arr===value;
  return `<button type="button" class="oph-tile${active?' active':''}" onclick="OPH.handleTile('${field}','${value.replace(/'/g,"\\'")}','${mode}', this)">${value}</button>`;
}
function tilesBlock(label, hint, field, options, mode){
  return `<div class="oph-field-block" data-field="${field}">
    <div class="oph-field-label">${label}${reqMark(field)}</div>
    ${hint?`<div class="oph-field-hint">${hint}</div>`:''}
    <div class="oph-tiles">${options.map(v=>tile(field,v,mode)).join('')}</div>
    <div class="oph-field-error" role="alert"></div>
  </div>`;
}
function textBlock(label, hint, field, placeholder, area){
  const tag = area ? `<textarea placeholder="${placeholder||''}" oninput="OPH.handleText('${field}', this.value)">${esc(state.data[field])}</textarea>`
                    : `<input type="text" value="${esc(state.data[field])}" placeholder="${placeholder||''}"${field==='email'?' inputmode="email" autocomplete="email"':''}${isRequired(field)?' aria-required="true"':''} oninput="OPH.handleText('${field}', this.value)">`;
  return `<div class="oph-field-block" data-field="${field}">
    <div class="oph-field-label">${label}${reqMark(field)}</div>
    ${hint?`<div class="oph-field-hint">${hint}</div>`:''}
    ${tag}
    <div class="oph-field-error" role="alert"></div>
  </div>`;
}
function sbRow(k,v){ return v ? `<div class="oph-sb-row"><span class="oph-k">${k}</span><span class="oph-v">${esc(v)}</span></div>` : ''; }
function sbChips(arr){ if(!arr||!arr.length) return ''; return `<div class="oph-sb-chips">${arr.map(v=>`<span class="oph-sb-chip">${esc(v)}</span>`).join('')}</div>`; }

let toastTimer = null;
function showToast(msg, duration){
  const t = document.getElementById('oph-toast');
  t.textContent = msg; t.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(()=>t.classList.remove('show'), duration || 1800);
}

const STATEMENT_BUILDERS = {
  creator: function(d){
    if(!d.blank1 && !d.blank2 && !d.blank3) return null;
    return `Ich erreiche <b>${esc(d.blank1)||'…'}</b> mit <b>${esc(d.blank2)||'…'}</b>. ${esc(d.blank3)?`<b>${esc(d.blank3)}</b> ist das, was meinen Content von anderen unterscheidet.`:'…'}`;
  },
  athlete: function(d){
    if(!d.blank1 && !d.blank2 && !d.blank3) return null;
    return `Ich trete an in <b>${esc(d.blank1)||'…'}</b> und stehe für <b>${esc(d.blank2)||'…'}</b>. ${esc(d.blank3)?`<b>${esc(d.blank3)}</b> ist mein Anspruch an diese Saison.`:'…'}`;
  }
};

const STECKBRIEF_TITLE_FIELD = { b2b:'companyName', creator:'name', athlete:'name', affiliate:'name' };

const STECKBRIEF_BUILDERS = {
  b2b: function(d){
    let s = '';
    if(d.companyName||d.contactName||d.role||d.website){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Unternehmen</div>
        ${sbRow('Firma', d.companyName)}${sbRow('Kontakt', d.contactName)}${sbRow('E-Mail', d.email)}${sbRow('Rolle', d.role)}${sbRow('Website', d.website)}</div>`;
    }
    if(d.businessType||d.locationsCount||d.customerBase){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Geschäftsmodell</div>
        ${sbRow('Art', d.businessType)}${sbRow('Standorte', d.locationsCount)}${sbRow('Kundschaft', d.customerBase)}</div>`;
    }
    if(d.cooperationType.length||d.productInterest.length){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Zusammenarbeit</div>
        ${sbChips(d.cooperationType)}${sbChips(d.productInterest)}</div>`;
    }
    if(d.region||d.estimatedVolume||d.deliveryRhythm){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Markt & Volumen</div>
        ${sbRow('Region', d.region)}${sbRow('Volumen', d.estimatedVolume)}${sbRow('Rhythmus', d.deliveryRhythm)}</div>`;
    }
    if(d.currentBrands||d.whyOrgainic){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Hintergrund</div>
        ${sbRow('Bestehende Marken', d.currentBrands)}${sbRow('Warum ORGAINIC', d.whyOrgainic)}</div>`;
    }
    return s;
  },
  creator: function(d){
    let s = '';
    if(d.name||d.qualification||d.whyOrgainic||d.email){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Über dich</div>
        ${sbRow('Name', d.name)}${sbRow('E-Mail', d.email)}${sbRow('Qualifikation', d.qualification)}${sbRow('Warum ORGAINIC', d.whyOrgainic)}</div>`;
    }
    if(d.sportFocus.length||d.contentFormats.length||d.blank1||d.blank2||d.blank3){
      const t = statementText();
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Positionierung</div>
        ${sbChips(d.sportFocus)}${sbChips(d.contentFormats)}${t?`<div class="oph-sb-quote">${t}</div>`:''}</div>`;
    }
    if(d.platforms.length||d.audienceSize||d.handles||d.audienceDescription){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Reichweite</div>
        ${sbChips(d.platforms)}${sbRow('Größe', d.audienceSize)}${sbRow('Handles', d.handles)}${sbRow('Audience', d.audienceDescription)}</div>`;
    }
    if(d.plannedVolume||d.availability||d.pastCollabs){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Content-Umfang</div>
        ${sbRow('Volumen', d.plannedVolume)}${sbRow('Verfügbarkeit', d.availability)}${sbRow('Kooperationen', d.pastCollabs)}</div>`;
    }
    if(d.usageRights||d.portfolio||d.notes){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Rechte & Sonstiges</div>
        ${sbRow('Nutzungsrechte', d.usageRights)}${sbRow('Portfolio', d.portfolio)}${sbRow('Notiz', d.notes)}</div>`;
    }
    return s;
  },
  athlete: function(d){
    let s = '';
    if(d.name||d.sportart||d.club||d.coach||d.email){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Über dich</div>
        ${sbRow('Name', d.name)}${sbRow('E-Mail', d.email)}${sbRow('Sportart', d.sportart)}${sbRow('Verein', d.club)}${sbRow('Trainer', d.coach)}</div>`;
    }
    if(d.level||d.achievements||d.license){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Leistungsniveau</div>
        ${sbRow('Niveau', d.level)}${sbRow('Erfolge', d.achievements)}${sbRow('Lizenz', d.license)}</div>`;
    }
    if(d.keyEvents||d.trainingLoad||d.seasonGoal){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Saison</div>
        ${sbRow('Wettkämpfe', d.keyEvents)}${sbRow('Trainingsumfang', d.trainingLoad)}${sbRow('Saisonziel', d.seasonGoal)}</div>`;
    }
    if(d.values.length||d.blank1||d.blank2||d.blank3){
      const t = statementText();
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Positionierung</div>
        ${sbChips(d.values)}${t?`<div class="oph-sb-quote">${t}</div>`:''}</div>`;
    }
    if(d.platforms.length||d.handles||d.mediaPresence||d.currentSponsors){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Sichtbarkeit</div>
        ${sbChips(d.platforms)}${sbRow('Handles', d.handles)}${sbRow('Medien', d.mediaPresence)}${sbRow('Sponsoren', d.currentSponsors)}</div>`;
    }
    if(d.supportType.length||d.availability){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Unterstützung</div>
        ${sbChips(d.supportType)}${sbRow('Verfügbarkeit', d.availability)}</div>`;
    }
    return s;
  },
  affiliate: function(d){
    let s = '';
    if(d.name||d.platformType||d.email||d.platformLink){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Über dich</div>
        ${sbRow('Name', d.name)}${sbRow('E-Mail', d.email)}${sbRow('Plattform', d.platformType)}${sbRow('Link', d.platformLink)}</div>`;
    }
    if(d.audienceSize||d.audienceDescription){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Reichweite</div>
        ${sbRow('Größe', d.audienceSize)}${sbRow('Audience', d.audienceDescription)}</div>`;
    }
    if(d.formats.length||d.frequency){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Empfehlung</div>
        ${sbChips(d.formats)}${sbRow('Frequenz', d.frequency)}</div>`;
    }
    if(d.pastPartnerships||d.trackingExperience){
      s += `<div class="oph-sb-section"><div class="oph-sb-section-title">Erfahrung</div>
        ${sbRow('Bisherige Partnerschaften', d.pastPartnerships)}${sbRow('Tracking-Erfahrung', d.trackingExperience)}</div>`;
    }
    return s;
  }
};

const CHAPTER_RENDERERS = {
  b2b: {
    unternehmen(step,total){
      const d = state.data;
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Unternehmen</h2>
      <p class="oph-lede">Damit wir wissen, mit wem wir sprechen.</p>
      ${textBlock('Firmenname','','companyName','z. B. Fit & Fresh GmbH')}
      ${textBlock('Ansprechpartner:in','','contactName','Vor- und Nachname')}
      ${textBlock('E-Mail','Für Rückfragen und die Weiterleitung an unser Vertriebsteam.','email','einkauf@eurefirma.de')}
      ${textBlock('Position / Rolle','','role','z. B. Einkauf, Geschäftsführung')}
      ${textBlock('Website','','website','www.eurewebsite.de')}`;
    },
    geschaeftsmodell(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Geschäftsmodell</h2>
      <p class="oph-lede">Womit handelt ihr, und wie groß seid ihr aufgestellt?</p>
      ${tilesBlock('Art des Geschäfts','','businessType', SECTIONS.b2b.options.businessType, 'single')}
      ${textBlock('Standorte / Reichweite','Anzahl Filialen, Größe des Online-Shops, o.ä.','locationsCount','z. B. 6 Filialen in Bayern')}
      ${textBlock('Eure Endkund:innen','Wer kauft bei euch ein?','customerBase','z. B. gesundheitsbewusste Berufstätige, 25-45')}`;
    },
    zusammenarbeit(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Art der Zusammenarbeit</h2>
      <p class="oph-lede">Was schwebt euch vor, und welche Produkte interessieren euch?</p>
      ${tilesBlock('Gewünschte Kooperationsform','Mehrfachauswahl möglich.','cooperationType', SECTIONS.b2b.options.cooperationType, 'multi')}
      ${tilesBlock('Produktinteresse', null, 'productInterest', SECTIONS.b2b.options.productInterest, 'multi')}`;
    },
    markt(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Markt & Volumen</h2>
      <p class="oph-lede">Die Zahlen, mit denen unser Vertrieb planen kann.</p>
      ${textBlock('Zielregion / Land','','region','z. B. Bayern, DACH-weit')}
      ${textBlock('Geschätztes Bestellvolumen','','estimatedVolume','z. B. 2.000 Einheiten / Quartal')}
      ${textBlock('Gewünschter Belieferungsrhythmus','','deliveryRhythm','z. B. monatlich')}`;
    },
    hintergrund(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Hintergrund</h2>
      <p class="oph-lede">Der letzte Kontext, bevor euer Steckbrief fertig ist.</p>
      ${textBlock('Aktuell geführte Marken','Wettbewerber oder Ergänzung im Sortiment.','currentBrands','z. B. Marke X, Marke Y')}
      ${textBlock('Warum ORGAINIC?','','whyOrgainic','', true)}`;
    }
  },
  creator: {
    ueberdich(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Über dich</h2>
      <p class="oph-lede">Erzähl uns kurz, wer du bist und was dich für eine Zusammenarbeit mit ORGAINIC qualifiziert.</p>
      ${textBlock('Name','Wie sollen wir dich nennen?','name','Vor- und Nachname')}
      ${textBlock('E-Mail','Damit wir dich bei Interesse erreichen können.','email','du@beispiel.de')}
      ${textBlock('Deine Qualifikation','Lizenzen, Ausbildung, Wettkampferfahrung, Beruf im Sport-/Ernährungsbereich.','qualification','z. B. lizenzierter Personal Trainer')}
      ${textBlock('Warum ORGAINIC?','Kurz und ehrlich.','whyOrgainic','', true)}`;
    },
    positionierung(step,total){
      const d = state.data;
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Sportart & Content-Positionierung</h2>
      <p class="oph-lede">Wofür steht dein Content? Mehrfachauswahl möglich.</p>
      ${tilesBlock('Sportliche Positionierung','', 'sportFocus', SECTIONS.creator.options.sportFocus, 'multi')}
      ${tilesBlock('Content-Formate','', 'contentFormats', SECTIONS.creator.options.contentFormats, 'multi')}
      <div class="oph-field-block">
        <div class="oph-field-label">Dein Positionierungssatz</div>
        <div class="oph-field-hint">Füll drei Lücken aus. So verstehen wir auf einen Blick, wofür du stehst.</div>
        <div class="oph-blank-row"><input type="text" value="${esc(d.blank1)}" placeholder="ambitionierte Hobby-Ausdauersportler zwischen 20 und 35" oninput="OPH.handleText('blank1', this.value)"></div>
        <div class="oph-blank-row"><input type="text" value="${esc(d.blank2)}" placeholder="ehrlichen Trainings- und Ernährungs-Insights" oninput="OPH.handleText('blank2', this.value)"></div>
        <div class="oph-blank-row"><input type="text" value="${esc(d.blank3)}" placeholder="ich teste Produkte wirklich über Wochen" oninput="OPH.handleText('blank3', this.value)"></div>
        <div id="oph-statementPreview"></div>
      </div>`;
    },
    reichweite(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Reichweite & Kanäle</h2>
      <p class="oph-lede">Auf welchen Plattformen bist du unterwegs, und wie groß ist deine Community?</p>
      ${tilesBlock('Plattformen', null, 'platforms', SECTIONS.creator.options.platforms, 'multi')}
      ${tilesBlock('Größenordnung deiner Reichweite','', 'audienceSize', SECTIONS.creator.options.audienceSize, 'single')}
      ${textBlock('Deine Handles','','handles','@dein.instagram, @dein.tiktok')}
      ${textBlock('Wer folgt dir hauptsächlich?','','audienceDescription','z. B. 70% weiblich, 25-40 Jahre')}`;
    },
    umfang(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Content-Umfang</h2>
      <p class="oph-lede">Wie viel Content stellst du dir vor, und ab wann bist du verfügbar?</p>
      ${textBlock('Geplantes Volumen','','plannedVolume','z. B. 4 Reels + 8 Stories pro Monat')}
      ${textBlock('Verfügbarkeit','','availability','z. B. ab sofort, mindestens 6 Monate')}
      ${textBlock('Bisherige Kooperationen','','pastCollabs','z. B. Marke X (2025)')}`;
    },
    rechte(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Rechte & Sonstiges</h2>
      <p class="oph-lede">Die letzten Details, bevor dein Steckbrief fertig ist.</p>
      ${tilesBlock('Nutzungsrechte an deinem Content','', 'usageRights', SECTIONS.creator.options.usageRights, 'single')}
      ${textBlock('Portfolio / bester Content','','portfolio','Link zu Reel, Video oder Portfolio')}
      ${textBlock('Sonst noch etwas?','','notes','', true)}`;
    }
  },
  athlete: {
    ueberdich(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Über dich</h2>
      <p class="oph-lede">Wer bist du, und in welcher Sportart trittst du an?</p>
      ${textBlock('Name','','name','Vor- und Nachname')}
      ${textBlock('E-Mail','Damit wir dich bei Interesse erreichen können.','email','du@beispiel.de')}
      ${tilesBlock('Sportart', null, 'sportart', SECTIONS.athlete.options.sportart, 'single')}
      ${textBlock('Verein / Team','','club','z. B. LG Frankfurt')}
      ${textBlock('Trainer / Coach','','coach','')}`;
    },
    leistung(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Leistungsniveau</h2>
      <p class="oph-lede">Wo stehst du aktuell, sportlich gesehen?</p>
      ${tilesBlock('Wettkampfklasse', null, 'level', SECTIONS.athlete.options.level, 'single')}
      ${textBlock('Aktuelle Erfolge / Platzierungen','','achievements','z. B. Deutsche Meisterschaft 2026, Platz 3', true)}
      ${textBlock('Lizenz / Verband','','license','')}`;
    },
    saison(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Wettkampfkalender</h2>
      <p class="oph-lede">Was steht diese Saison an, und wie sieht dein Training aus?</p>
      ${textBlock('Wichtigste Wettkämpfe der Saison','','keyEvents','', true)}
      ${textBlock('Trainingsumfang','','trainingLoad','z. B. 12 Stunden / Woche')}
      ${textBlock('Saisonhöhepunkt / Ziel','','seasonGoal','z. B. Qualifikation für die EM')}`;
    },
    positionierung(step,total){
      const d = state.data;
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Positionierung</h2>
      <p class="oph-lede">Wofür stehst du als Athlet:in? Mehrfachauswahl möglich.</p>
      ${tilesBlock('Deine Werte', null, 'values', SECTIONS.athlete.options.values, 'multi')}
      <div class="oph-field-block">
        <div class="oph-field-label">Dein Positionierungssatz</div>
        <div class="oph-field-hint">Drei Lücken füllen.</div>
        <div class="oph-blank-row"><input type="text" value="${esc(d.blank1)}" placeholder="im Marathon, Amateurklasse" oninput="OPH.handleText('blank1', this.value)"></div>
        <div class="oph-blank-row"><input type="text" value="${esc(d.blank2)}" placeholder="ehrliche Leistung ohne Abkürzungen" oninput="OPH.handleText('blank2', this.value)"></div>
        <div class="oph-blank-row"><input type="text" value="${esc(d.blank3)}" placeholder="eine persönliche Bestzeit zu laufen" oninput="OPH.handleText('blank3', this.value)"></div>
        <div id="oph-statementPreview"></div>
      </div>`;
    },
    sichtbarkeit(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Sichtbarkeit</h2>
      <p class="oph-lede">Hilft uns bei der Einschätzung, ist aber kein Muss.</p>
      ${tilesBlock('Plattformen', null, 'platforms', SECTIONS.athlete.options.platforms, 'multi')}
      ${textBlock('Handles','','handles','@dein.profil')}
      ${textBlock('Medienpräsenz','TV, Print, Interviews','mediaPresence','')}
      ${textBlock('Bestehende Sponsoren','','currentSponsors','')}`;
    },
    unterstuetzung(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Was du dir vorstellst</h2>
      <p class="oph-lede">Welche Unterstützung wäre für dich am wertvollsten?</p>
      ${tilesBlock('Gewünschte Unterstützung','Mehrfachauswahl möglich.', 'supportType', SECTIONS.athlete.options.supportType, 'multi')}
      ${textBlock('Verfügbarkeit / Zeitraum','','availability','z. B. ab sofort, für die kommende Saison')}`;
    }
  },
  affiliate: {
    ueberdich(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Über dich & deine Plattform</h2>
      <p class="oph-lede">Wo und wie erreichst du deine Zielgruppe?</p>
      ${textBlock('Name','','name','Vor- und Nachname, oder Marke/Projekt')}
      ${textBlock('E-Mail','Damit wir dich bei Interesse erreichen können.','email','du@beispiel.de')}
      ${tilesBlock('Art der Plattform', null, 'platformType', SECTIONS.affiliate.options.platformType, 'single')}
      ${textBlock('Link zu deiner Plattform','Newsletter-Anmeldung, Podcast, Website oder Profil, damit wir sie uns anschauen können.','platformLink','z. B. www.dein-newsletter.de')}`;
    },
    reichweite(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Reichweite</h2>
      <p class="oph-lede">Eine grobe Einschätzung reicht völlig.</p>
      ${tilesBlock('Größenordnung', null, 'audienceSize', SECTIONS.affiliate.options.audienceSize, 'single')}
      ${textBlock('Wer ist deine Zielgruppe?','','audienceDescription','z. B. Hobby-Sportler:innen, 30-50 Jahre')}`;
    },
    empfehlung(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Wie du empfiehlst</h2>
      <p class="oph-lede">In welcher Form würdest du ORGAINIC weiterempfehlen?</p>
      ${tilesBlock('Format', null, 'formats', SECTIONS.affiliate.options.formats, 'multi')}
      ${textBlock('Geplante Frequenz','','frequency','z. B. 1x im Monat im Newsletter')}`;
    },
    erfahrung(step,total){
      return `<div class="oph-kicker">Kapitel ${step+1} / ${total}</div>
      <h2>Erfahrung</h2>
      <p class="oph-lede">Die letzten Details.</p>
      ${textBlock('Bisherige Partnerschaften','','pastPartnerships','')}
      ${tilesBlock('Erfahrung mit Rabattcodes / Trackinglinks', null, 'trackingExperience', SECTIONS.affiliate.options.trackingExperience, 'single')}`;
    }
  }
};

const SUMMARY_RENDERERS = {
  b2b(){
    const d = state.data;
    return `<div class="oph-kicker">Kapitel ${SECTIONS.b2b.chapters.length} / ${SECTIONS.b2b.chapters.length}</div>
    <h2>Zusammenfassung</h2>
    <p class="oph-lede">Prüft eure Angaben und schickt die Anfrage direkt an unser Vertriebsteam.</p>
    <div class="oph-summary-block">
      <h3>Unternehmen</h3><div class="oph-sline"><b>${esc(d.companyName)||'-'}</b> · ${esc(d.contactName)||'-'} · ${esc(d.email)||'-'} · ${esc(d.role)||'-'}</div>
      <h3>Geschäftsmodell</h3><div class="oph-sline">${esc(d.businessType)||'-'} · ${esc(d.locationsCount)||'-'}</div>
      <h3>Zusammenarbeit</h3><div class="oph-sline">${d.cooperationType.join(', ')||'-'}</div>
      <h3>Markt & Volumen</h3><div class="oph-sline">${esc(d.region)||'-'} · ${esc(d.estimatedVolume)||'-'}</div>
    </div>`;
  },
  creator(){
    const d = state.data; const t = statementText();
    return `<div class="oph-kicker">Kapitel ${SECTIONS.creator.chapters.length} / ${SECTIONS.creator.chapters.length}</div>
    <h2>Dein Steckbrief</h2>
    <p class="oph-lede">So kommt deine Bewerbung bei uns an.</p>
    <div class="oph-summary-block">
      <h3>Über dich</h3><div class="oph-sline"><b>${esc(d.name)||'-'}</b> · ${esc(d.email)||'-'} · ${esc(d.qualification)||'-'}</div>
      <h3>Positionierung</h3><div class="oph-sline">${(d.sportFocus.concat(d.contentFormats)).join(', ')||'-'}</div>
      ${t?`<div class="oph-sb-quote" style="margin-top:8px;">${t}</div>`:''}
      <h3>Reichweite</h3><div class="oph-sline">${d.platforms.join(', ')||'-'} · ${esc(d.audienceSize)||'-'}</div>
    </div>`;
  },
  athlete(){
    const d = state.data; const t = statementText();
    return `<div class="oph-kicker">Kapitel ${SECTIONS.athlete.chapters.length} / ${SECTIONS.athlete.chapters.length}</div>
    <h2>Dein Steckbrief</h2>
    <p class="oph-lede">So kommt deine Bewerbung bei uns an.</p>
    <div class="oph-summary-block">
      <h3>Über dich</h3><div class="oph-sline"><b>${esc(d.name)||'-'}</b> · ${esc(d.email)||'-'} · ${esc(d.sportart)||'-'} · ${esc(d.level)||'-'}</div>
      <h3>Positionierung</h3><div class="oph-sline">${d.values.join(', ')||'-'}</div>
      ${t?`<div class="oph-sb-quote" style="margin-top:8px;">${t}</div>`:''}
      <h3>Unterstützung</h3><div class="oph-sline">${d.supportType.join(', ')||'-'}</div>
    </div>`;
  },
  affiliate(){
    const d = state.data;
    return `<div class="oph-kicker">Kapitel ${SECTIONS.affiliate.chapters.length} / ${SECTIONS.affiliate.chapters.length}</div>
    <h2>Dein Steckbrief</h2>
    <p class="oph-lede">So kommt deine Bewerbung bei uns an.</p>
    <div class="oph-summary-block">
      <h3>Über dich</h3><div class="oph-sline"><b>${esc(d.name)||'-'}</b> · ${esc(d.email)||'-'} · ${esc(d.platformType)||'-'} · ${esc(d.platformLink)||'-'}</div>
      <h3>Reichweite</h3><div class="oph-sline">${esc(d.audienceSize)||'-'}</div>
      <h3>Empfehlung</h3><div class="oph-sline">${d.formats.join(', ')||'-'} · ${esc(d.frequency)||'-'}</div>
    </div>`;
  }
};

const EXPORT_MODEL_BUILDERS = {
  b2b(d){
    return { title: 'B2B-Anfrage', groups: [
      {title:'Unternehmen', fields:[
        {label:'Firma', value:d.companyName},{label:'Kontakt', value:d.contactName},
        {label:'E-Mail', value:d.email},{label:'Rolle', value:d.role},{label:'Website', value:d.website}]},
      {title:'Geschäftsmodell', fields:[
        {label:'Art', value:d.businessType},{label:'Standorte', value:d.locationsCount},
        {label:'Kundschaft', value:d.customerBase}]},
      {title:'Zusammenarbeit', fields:[
        {label:'Kooperationsform', value:d.cooperationType.join(', ')},
        {label:'Produktinteresse', value:d.productInterest.join(', ')}]},
      {title:'Markt & Volumen', fields:[
        {label:'Region', value:d.region},{label:'Volumen', value:d.estimatedVolume},
        {label:'Rhythmus', value:d.deliveryRhythm}]},
      {title:'Hintergrund', fields:[
        {label:'Bestehende Marken', value:d.currentBrands},{label:'Warum ORGAINIC', value:d.whyOrgainic}]}
    ]};
  },
  creator(d){
    return { title: 'Creator & Affiliate Steckbrief', groups: [
      {title:'Über dich', fields:[
        {label:'Name', value:d.name},{label:'E-Mail', value:d.email},{label:'Qualifikation', value:d.qualification},{label:'Warum ORGAINIC', value:d.whyOrgainic}]},
      {title:'Positionierung', fields:[
        {label:'Sportliche Positionierung', value:d.sportFocus.join(', ')},
        {label:'Content-Formate', value:d.contentFormats.join(', ')}], quote: plainStatement()},
      {title:'Reichweite & Kanäle', fields:[
        {label:'Plattformen', value:d.platforms.join(', ')},{label:'Größenordnung', value:d.audienceSize},
        {label:'Handles', value:d.handles},{label:'Audience', value:d.audienceDescription}]},
      {title:'Content-Umfang', fields:[
        {label:'Geplantes Volumen', value:d.plannedVolume},{label:'Verfügbarkeit', value:d.availability},
        {label:'Bisherige Kooperationen', value:d.pastCollabs}]},
      {title:'Rechte & Sonstiges', fields:[
        {label:'Nutzungsrechte', value:d.usageRights},{label:'Portfolio', value:d.portfolio},{label:'Notiz', value:d.notes}]}
    ]};
  },
  athlete(d){
    return { title: 'Athleten-Steckbrief', groups: [
      {title:'Über dich', fields:[
        {label:'Name', value:d.name},{label:'E-Mail', value:d.email},{label:'Sportart', value:d.sportart},
        {label:'Verein', value:d.club},{label:'Trainer', value:d.coach}]},
      {title:'Leistungsniveau', fields:[
        {label:'Niveau', value:d.level},{label:'Erfolge', value:d.achievements},{label:'Lizenz', value:d.license}]},
      {title:'Wettkampfkalender', fields:[
        {label:'Wettkämpfe', value:d.keyEvents},{label:'Trainingsumfang', value:d.trainingLoad},{label:'Saisonziel', value:d.seasonGoal}]},
      {title:'Positionierung', fields:[
        {label:'Werte', value:d.values.join(', ')}], quote: plainStatement()},
      {title:'Sichtbarkeit', fields:[
        {label:'Plattformen', value:d.platforms.join(', ')},{label:'Handles', value:d.handles},
        {label:'Medien', value:d.mediaPresence},{label:'Sponsoren', value:d.currentSponsors}]},
      {title:'Unterstützung', fields:[
        {label:'Gewünschte Unterstützung', value:d.supportType.join(', ')},{label:'Verfügbarkeit', value:d.availability}]}
    ]};
  },
  affiliate(d){
    return { title: 'Affiliate-Steckbrief', groups: [
      {title:'Über dich', fields:[
        {label:'Name', value:d.name},{label:'E-Mail', value:d.email},{label:'Plattform', value:d.platformType},{label:'Link', value:d.platformLink}]},
      {title:'Reichweite', fields:[
        {label:'Größenordnung', value:d.audienceSize},{label:'Audience', value:d.audienceDescription}]},
      {title:'Empfehlung', fields:[
        {label:'Format', value:d.formats.join(', ')},{label:'Frequenz', value:d.frequency}]},
      {title:'Erfahrung', fields:[
        {label:'Bisherige Partnerschaften', value:d.pastPartnerships},{label:'Tracking-Erfahrung', value:d.trackingExperience}]}
    ]};
  }
};

function renderRouter(){
  const el = document.getElementById('oph-router');
  const order = ['b2b','creator','athlete','affiliate'];
  el.innerHTML = `
    <div class="oph-router-hero">
      ${CFG.kicker?`<div class="oph-router-kicker">${esc(CFG.kicker)}</div>`:''}
      <h1>${esc(CFG.heading)}</h1>
      ${CFG.intro?`<p>${esc(CFG.intro)}</p>`:''}
    </div>
    <div class="oph-router-grid">
      ${order.map((key,i)=>{
        const s = SECTIONS[key];
        return `<button type="button" class="oph-router-card" style="--card-bg:url('${CARD_BG[key]}')" onclick="OPH.selectSection('${key}')">
          <div class="oph-rc-num">0${i+1}</div>
          <h3>${s.label}</h3>
          <p>${s.cardDesc}</p>
          <div class="oph-rc-go">Auswählen →</div>
        </button>`;
      }).join('')}
    </div>
  `;
  document.getElementById('oph-router').style.display='block';
  document.getElementById('oph-appLayout').style.display='none';
  document.getElementById('oph-refCode').textContent = '-';
  document.getElementById('oph-refNote').textContent = 'Wähle unten deine Kategorie';
}

function selectSection(key){
  state.section = key;
  state.step = 0;
  state.data = JSON.parse(JSON.stringify(SECTIONS[key].defaultData));
  state.ref = genRef(SECTIONS[key].refPrefix);
  document.getElementById('oph-refCode').textContent = state.ref;
  document.getElementById('oph-refNote').textContent = SECTIONS[key].refNote;
  document.getElementById('oph-router').style.display='none';
  document.getElementById('oph-appLayout').style.display='block';
  renderAll();
  lockHeight();
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(lockHeight);
  scrollToHub();
}

function backToRouter(){
  state.section = null;
  state.step = 0;
  state.data = {};
  renderRouter();
}

function renderAll(){
  renderSidebar();
  renderMain();
  renderSteckbrief();
}

function renderSidebar(){
  const sec = SECTIONS[state.section];
  const el = document.getElementById('oph-sidebar');
  const items = sec.chapters.map((c,i)=>{
    const isActive = i===state.step;
    const isDone = i<state.step;
    return `<div class="oph-chapter-item${isActive?' active':''}" onclick="OPH.goToStep(${i})">
      <div class="oph-chnum${isDone?' check':''}">${isDone?'✓':(i+1)}</div>
      <div><div class="oph-chtitle">${c.title}${(c.id!=='summary' && !requiredFor(c.id).length)?' <span class="oph-chopt">optional</span>':''}</div><div class="oph-chdesc">${c.desc}</div></div>
    </div>`;
  }).join('');
  el.innerHTML = `<span class="oph-switch-section" onclick="OPH.backToRouter()">← andere Kategorie</span>` + items;

  const prog = document.getElementById('oph-progressRow');
  prog.innerHTML = sec.chapters.map((c,i)=>{
    let cls=''; if(i<state.step) cls='done'; else if(i===state.step) cls='current';
    return `<div class="oph-progress-seg ${cls}"></div>`;
  }).join('');
}

/* Feste Höhe: der Fragebogen ist immer so hoch wie sein längstes Kapitel (nur Desktop) */
function lockHeight(){
  const main = document.getElementById('oph-main');
  if(!main || !state.section) return;
  main.style.minHeight = '';
  if(window.innerWidth <= 980) return;
  const sec = SECTIONS[state.section];
  const current = state.step;
  let max = 0;
  for(let i=0;i<sec.chapters.length;i++){
    state.step = i;
    renderMain();
    max = Math.max(max, main.offsetHeight);
  }
  state.step = current;
  renderMain();
  main.style.minHeight = max + 'px';
}
let resizeTimer = null;
window.addEventListener('resize', ()=>{
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(lockHeight, 200);
});

function goToStep(n){
  const sec = SECTIONS[state.section];
  if(n<0 || n>=sec.chapters.length) return;
  state.step = n;
  renderAll();
  scrollToHub();
}

function nextStep(toSummary){
  const sec = SECTIONS[state.section];
  const missing = missingIn(sec.chapters[state.step].id);
  if(missing.length){
    markInvalid(missing);
    showToast(missing.length===1 ? 'Bitte fülle das Pflichtfeld aus.' : 'Bitte fülle die Pflichtfelder aus.', 3000);
    return;
  }
  goToStep(toSummary ? sec.chapters.length-1 : state.step+1);
}

function handleTile(field, value, mode, elBtn){
  if(mode==='multi'){
    const arr = state.data[field];
    const idx = arr.indexOf(value);
    if(idx>-1) arr.splice(idx,1); else arr.push(value);
    elBtn.classList.toggle('active');
  } else {
    state.data[field] = (state.data[field]===value) ? '' : value;
    elBtn.parentElement.querySelectorAll('.oph-tile').forEach(t=>t.classList.remove('active'));
    if(state.data[field]===value) elBtn.classList.add('active');
  }
  clearInvalid(field);
  renderSteckbrief();
}
function handleText(field, value){
  state.data[field] = value;
  if(['blank1','blank2','blank3'].includes(field)) updateStatementPreview();
  clearInvalid(field);
  renderSteckbrief();
}
function resetAll(){
  const key = state.section;
  selectSection(key);
}

function renderMain(){
  const sec = SECTIONS[state.section];
  const step = state.step;
  const c = sec.chapters[step];
  const el = document.getElementById('oph-main');
  const body = (c.id==='summary') ? renderSummary() : CHAPTER_RENDERERS[state.section][c.id](step, sec.chapters.length);

  const isFirst = step===0;
  const isLast = step===sec.chapters.length-1;
  const summaryStep = sec.chapters.length-1;
  let note = '';
  if(c.id!=='summary'){
    note = requiredFor(c.id).length
      ? `<p class="oph-req-note"><span class="oph-req">*</span> Pflichtangabe. Alles andere ist freiwillig.</p>`
      : `<p class="oph-req-note">Alle Angaben in diesem Kapitel sind freiwillig.</p>`;
  }
  const canSkip = !isLast && step < summaryStep-1 && allMissing().length===0;
  el.innerHTML = `${body}${note}
    <div class="oph-nav-row">
      <button type="button" class="oph-btn oph-secondary" ${isFirst?'disabled':''} onclick="OPH.goToStep(${step-1})">← Zurück</button>
      ${!isLast ? `<div class="oph-nav-next">
          ${canSkip ? `<button type="button" class="oph-btn oph-secondary" onclick="OPH.nextStep(true)">Direkt zur Zusammenfassung</button>` : ''}
          <button type="button" class="oph-btn" onclick="OPH.nextStep()">Weiter →</button>
        </div>` : `<button type="button" class="oph-btn oph-secondary" onclick="OPH.resetAll()">Neu starten</button>`}
    </div>`;

  if(['positionierung'].includes(c.id) && STATEMENT_BUILDERS[state.section]) updateStatementPreview();
}

function statementText(){
  const fn = STATEMENT_BUILDERS[state.section];
  return fn ? fn(state.data) : null;
}
function updateStatementPreview(){
  const t = statementText();
  const box = document.getElementById('oph-statementPreview');
  if(!box) return;
  box.innerHTML = t ? `<div class="oph-statement-preview">${t}</div>` : `<div class="oph-statement-preview empty">Fülle die Lücken oben aus, der Satz baut sich hier live zusammen.</div>`;
}
function plainStatement(){
  const t = statementText();
  if(!t) return '';
  const tmp = document.createElement('div');
  tmp.innerHTML = t;
  return tmp.textContent;
}

function renderSteckbrief(){
  const el = document.getElementById('oph-steckbrief');
  const d = state.data;
  const sec = SECTIONS[state.section];
  const sections = STECKBRIEF_BUILDERS[state.section](d);
  const titleField = STECKBRIEF_TITLE_FIELD[state.section];
  el.innerHTML = `<div class="oph-sb-head">Steckbrief</div><div class="oph-sb-title">${esc(d[titleField])||'Unbenannt'}</div>
    ${sections || `<div class="oph-sb-empty">Beginne mit Kapitel 1,<br>der Steckbrief baut sich hier auf.</div>`}`;
}

function renderSummary(){
  const sec = SECTIONS[state.section];
  const submitLabel = state.section==='b2b' ? 'Anfrage absenden' : 'Bewerbung absenden';
  const missing = allMissing();
  const missingBox = missing.length ? `<div class="oph-missing">
      <b>Es fehlen noch Pflichtangaben:</b>
      <ul>${missing.map(m=>`<li><a href="#" onclick="OPH.fixField(${m.step},'${m.field}');return false;">${REQUIRED_LABELS[m.field]||m.field}</a> <span>· ${sec.chapters[m.step].title}</span></li>`).join('')}</ul>
    </div>` : '';
  return SUMMARY_RENDERERS[state.section]() + missingBox + `
    <div class="oph-summary-actions">
      <button type="button" class="oph-btn" id="oph-submit" onclick="OPH.submitRequest()">${submitLabel}</button>
      <button type="button" class="oph-btn oph-secondary" onclick="OPH.downloadPDF()">Als PDF herunterladen</button>
      <button type="button" class="oph-btn oph-secondary" onclick="OPH.copySummary()">Text kopieren</button>
    </div>
    <p class="oph-consent">Mit dem Absenden werden die Angaben an das ORGAINIC-Team übermittelt und zur Bearbeitung in unserem Kundensystem (Klaviyo) gespeichert. Eine Newsletter-Anmeldung erfolgt nicht.${CFG.privacyUrl?` Mehr dazu in der <a href="${esc(CFG.privacyUrl)}" target="_blank" rel="noopener">Datenschutzerklärung</a>.`:''}</p>`;
}

function copySummary(){
  const text = buildSummaryText();
  if(navigator.clipboard && navigator.clipboard.writeText){
    navigator.clipboard.writeText(text).then(()=>showToast('Kopiert.')).catch(()=>fallbackCopy(text));
  } else { fallbackCopy(text); }
}
function fallbackCopy(text){
  const ta = document.createElement('textarea');
  ta.value = text; document.body.appendChild(ta); ta.select();
  try{ document.execCommand('copy'); showToast('Kopiert.'); }catch(e){ showToast('Kopieren nicht möglich.'); }
  document.body.removeChild(ta);
}

function buildSummaryText(){
  const sec = SECTIONS[state.section];
  const model = EXPORT_MODEL_BUILDERS[state.section](state.data);
  const lines = [];
  lines.push('ORGAINIC · '+model.title.toUpperCase());
  lines.push('Referenz: '+state.ref);
  model.groups.forEach(g=>{
    lines.push('');
    lines.push(g.title.toUpperCase());
    g.fields.forEach(f=>lines.push(f.label+': '+(f.value||'-')));
    if(g.quote) lines.push('Positionierungssatz: '+(g.quote||'-'));
  });
  return lines.join('\n');
}

function buildPDF(){
  try{
    const sec = SECTIONS[state.section];
    const model = EXPORT_MODEL_BUILDERS[state.section](state.data);
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({unit:'pt', format:'a4'});
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const marginX = 50;
    const contentW = pageW - marginX*2;
    let y = 0;

    function drawHeader(cont){
      doc.setFillColor(20,20,20);
      doc.rect(0,0,pageW, cont?58:108,'F');
      const iconH = cont?20:32;
      doc.addImage(ICON_B64,'PNG', marginX, cont?19:30, iconH, iconH);
      const wmH = cont?13:21;
      const wmW = wmH*(756/118);
      doc.addImage(WORD_B64,'PNG', marginX+iconH+12, cont? (19+(iconH-wmH)/2) : (30+(iconH-wmH)/2), wmW, wmH);
      if(!cont){
        doc.setFont('helvetica','normal'); doc.setFontSize(9);
        doc.setTextColor(175,175,170);
        doc.text(model.title, marginX+iconH+12, 30+wmH+(iconH-wmH)/2+13);
      }
      doc.setFont('courier','normal'); doc.setFontSize(9);
      doc.setTextColor(215,215,210);
      doc.text(state.ref, pageW-marginX, cont?27:38, {align:'right'});
      if(!cont){
        doc.setFont('helvetica','normal'); doc.setFontSize(7.5);
        doc.setTextColor(150,150,145);
        doc.text('Vertraulich', pageW-marginX, 52, {align:'right'});
      }
      return (cont?58:108)+22;
    }
    function checkPage(needed){ if(y+needed > pageH-70){ doc.addPage(); y = drawHeader(true); } }
    function sectionTitle(t){
      checkPage(30);
      doc.setFont('helvetica','bold'); doc.setFontSize(10.5);
      doc.setTextColor(20,20,20);
      doc.text(t.toUpperCase(), marginX, y);
      y += 7;
      doc.setDrawColor(205,205,200); doc.setLineWidth(0.75);
      doc.line(marginX, y, pageW-marginX, y);
      y += 16;
    }
    function field(label, value){
      if(!value) return;
      doc.setFont('helvetica','normal'); doc.setFontSize(8.5);
      const lines = doc.splitTextToSize(String(value), contentW);
      checkPage(12+lines.length*13.5+12);
      doc.setTextColor(120,120,115);
      doc.text(label.toUpperCase(), marginX, y);
      y += 12;
      doc.setFont('helvetica','normal'); doc.setFontSize(11);
      doc.setTextColor(25,25,25);
      doc.text(lines, marginX, y);
      y += lines.length*13.5 + 12;
    }
    function quoteField(label, text){
      if(!text) return;
      doc.setFont('helvetica','italic'); doc.setFontSize(11);
      const lines = doc.splitTextToSize('„'+text+'"', contentW);
      checkPage(12+lines.length*13.5+12);
      doc.setFont('helvetica','normal'); doc.setFontSize(8.5);
      doc.setTextColor(120,120,115);
      doc.text(label.toUpperCase(), marginX, y);
      y += 12;
      doc.setFont('helvetica','italic'); doc.setFontSize(11);
      doc.setTextColor(25,25,25);
      doc.text(lines, marginX, y);
      y += lines.length*13.5 + 12;
    }

    y = drawHeader(false);
    model.groups.forEach(g=>{
      sectionTitle(g.title);
      g.fields.forEach(f=>field(f.label, f.value));
      if(g.quote) quoteField('Positionierungssatz', g.quote);
    });

    const totalPages = doc.internal.getNumberOfPages();
    for(let i=1;i<=totalPages;i++){
      doc.setPage(i);
      doc.setFont('helvetica','normal'); doc.setFontSize(8);
      doc.setTextColor(150,150,145);
      doc.text('ORGAINIC · '+state.ref+' · vertraulich', marginX, pageH-30);
      doc.text(String(i)+' / '+totalPages, pageW-marginX, pageH-30, {align:'right'});
    }
    doc.save(state.ref+'.pdf');
  }catch(e){
    console.error(e);
    showToast('PDF-Erstellung fehlgeschlagen.');
  }
}


/* ---------- Scroll ---------- */
function scrollToHub(){
  if(!root) return;
  if(root.getBoundingClientRect().top < 0) root.scrollIntoView({behavior:'smooth', block:'start'});
}

/* ---------- PDF (jsPDF + Logos werden erst bei Bedarf geladen) ---------- */
function loadScript(src){
  return new Promise((resolve, reject)=>{
    if(window.jspdf) return resolve();
    const s = document.createElement('script');
    s.src = src; s.onload = resolve; s.onerror = reject;
    document.head.appendChild(s);
  });
}
function toDataURL(url){
  return fetch(url).then(r=>r.blob()).then(b=>new Promise((resolve, reject)=>{
    const fr = new FileReader();
    fr.onload = ()=>resolve(fr.result); fr.onerror = reject;
    fr.readAsDataURL(b);
  }));
}
function downloadPDF(){
  showToast('PDF wird erstellt …');
  Promise.all([
    loadScript(JSPDF_URL),
    ICON_B64 || toDataURL(CFG.logoIcon).then(u=>{ ICON_B64 = u; }),
    WORD_B64 || toDataURL(CFG.logoWord).then(u=>{ WORD_B64 = u; })
  ]).then(buildPDF).catch(e=>{
    console.error(e);
    showToast('PDF-Erstellung fehlgeschlagen.');
  });
}

/* ---------- Absenden an Klaviyo (Client API, Event "Partner Anfrage") ---------- */
const KLAVIYO_METRIC = 'Partner Anfrage';
const KLAVIYO_NOTIFY_METRIC = 'Partner Anfrage Benachrichtigung';

function sendToKlaviyo(payload){
  return fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(CFG.klaviyoId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2026-07-15' },
    body: JSON.stringify(payload)
  }).then(r=>{ if(!r.ok) throw new Error('Klaviyo ' + r.status); });
}

/* Kopie jeder Anfrage ins Google Sheet (Apps Script), blockiert den Versand nicht */
function sendToSheet(props){
  if(!CFG.sheetUrl) return;
  try {
    fetch(CFG.sheetUrl, {
      method: 'POST', mode: 'no-cors', keepalive: true,
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ token: CFG.sheetToken, kategorie_key: props.kategorie_key, referenz: props.referenz, seite: props.seite, statement: plainStatement(), daten: props.daten })
    }).catch(e=>console.error('Partner Hub: Sheet fehlgeschlagen', e));
  } catch(e){ console.error('Partner Hub: Sheet fehlgeschlagen', e); }
}

function fixField(step, field){
  goToStep(step);
  markInvalid(missingIn(SECTIONS[state.section].chapters[step].id));
}

function submitRequest(){
  const d = state.data;
  const missing = allMissing();
  if(missing.length){
    fixField(missing[0].step, missing[0].field);
    showToast('Bitte ergänze noch die Pflichtangaben.', 4000);
    return;
  }
  const email = String(d.email||'').trim();
  if(!CFG.klaviyoId){ showToast('Absenden gerade nicht möglich.', 4000); return; }
  const sec = SECTIONS[state.section];
  const name = state.section==='b2b'
    ? [d.contactName, d.companyName].filter(Boolean).join(' · ')
    : (d.name||'');
  const personName = String(state.section==='b2b' ? (d.contactName||'') : (d.name||'')).trim();
  const firstName = personName.split(/\s+/)[0] || '';
  const lastName = personName.split(/\s+/).slice(1).join(' ');
  const daten = {};
  Object.keys(d).forEach(k=>{ daten[k] = Array.isArray(d[k]) ? d[k].join(', ') : d[k]; });

  const profile = { email: email };
  if(firstName) profile.first_name = firstName;
  if(lastName) profile.last_name = lastName;
  if(state.section==='b2b' && d.companyName) profile.organization = d.companyName;

  const payload = { data: { type: 'event', attributes: {
    properties: {
      kategorie: sec.subtitle,
      kategorie_key: state.section,
      referenz: state.ref,
      name: name,
      email: email,
      zusammenfassung: buildSummaryText(),
      seite: location.href.split('?')[0],
      daten: daten
    },
    unique_id: state.ref,
    metric: { data: { type: 'metric', attributes: { name: KLAVIYO_METRIC } } },
    profile: { data: { type: 'profile', attributes: profile } }
  } } };

  // Zweites Event auf das interne Empfänger-Profil -> Flow schickt die Benachrichtigungs-Mail
  // je Empfänger ein eigenes Event -> der Flow schickt jedem eine Mail
  const notify = Promise.all(CFG.notifyEmails.map((addr, i)=>sendToKlaviyo({ data: { type: 'event', attributes: {
    properties: payload.data.attributes.properties,
    unique_id: state.ref + '-notify-' + (i+1),
    metric: { data: { type: 'metric', attributes: { name: KLAVIYO_NOTIFY_METRIC } } },
    profile: { data: { type: 'profile', attributes: { email: addr } } }
  } } })));

  sendToSheet(payload.data.attributes.properties);

  const btn = document.getElementById('oph-submit');
  if(btn){ btn.disabled = true; btn.textContent = 'Wird gesendet …'; }
  Promise.all([sendToKlaviyo(payload), notify]).then(()=>{
    renderSuccess({ section: state.section, data: state.data, ref: state.ref });
    scrollToHub();
  }).catch(e=>{
    console.error('Partner Hub: Senden an Klaviyo fehlgeschlagen', e);
    if(btn){ btn.disabled = false; btn.textContent = state.section==='b2b' ? 'Erneut versuchen' : 'Erneut versuchen'; }
    showSendFallback();
  });
}

/* Wenn Klaviyo nicht erreichbar ist (z.B. Werbeblocker): Hinweis + Versand per E-Mail anbieten */
function showSendFallback(){
  const main = document.getElementById('oph-main');
  if(!main) return;
  const isB2B = state.section==='b2b';
  const to = CFG.notifyEmails[0] || '';
  const sec = SECTIONS[state.section];
  let box = main.querySelector('.oph-send-fallback');
  if(!box){
    box = document.createElement('div');
    box.className = 'oph-send-fallback';
    box.setAttribute('role','alert');
    const actions = main.querySelector('.oph-summary-actions');
    if(actions) actions.parentNode.insertBefore(box, actions); else main.appendChild(box);
  }
  const subject = sec.subtitle + ' ' + state.ref;
  const mailto = to ? 'mailto:' + to + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(buildSummaryText()) : '';
  box.innerHTML = `<b>${isB2B ? 'Eure Anfrage konnte nicht gesendet werden.' : 'Deine Bewerbung konnte nicht gesendet werden.'}</b>
    <p>Das liegt meist an einem Werbe- oder Tracking-Blocker im Browser. ${isB2B ? 'Versucht es erneut oder schickt uns den Steckbrief direkt per E-Mail.' : 'Versuch es erneut oder schick uns deinen Steckbrief direkt per E-Mail.'}</p>
    ${mailto ? `<a class="oph-btn oph-secondary oph-mail-btn" href="${esc(mailto)}">Per E-Mail senden</a>` : ''}`;
  box.scrollIntoView({behavior:'smooth', block:'center'});
}

function renderSuccess(saved){
  const el = document.getElementById('oph-router');
  const isB2B = saved && saved.section==='b2b';
  const firstName = saved && saved.data ? String(isB2B ? (saved.data.contactName||'') : (saved.data.name||'')).trim().split(/\s+/)[0] : '';
  el.innerHTML = `
    <div class="oph-router-hero oph-success">
      <div class="oph-router-kicker">${isB2B ? 'Anfrage gesendet' : 'Bewerbung gesendet'}</div>
      <h1>Danke${firstName ? ', '+esc(firstName) : ''}!</h1>
      <p>${isB2B ? 'Eure Anfrage ist bei uns angekommen. Unser Vertriebsteam meldet sich per E-Mail bei euch.' : 'Deine Bewerbung ist bei uns angekommen. Wir melden uns per E-Mail bei dir.'}</p>
      ${saved && saved.ref ? `<div class="oph-success-ref">Referenz <b>${esc(saved.ref)}</b></div>` : ''}
      <div class="oph-summary-actions">
        ${saved ? `<button type="button" class="oph-btn oph-secondary" onclick="OPH.downloadPDF()">Steckbrief als PDF</button>` : ''}
        <button type="button" class="oph-btn" onclick="OPH.backToRouter()">Neue Anfrage starten</button>
      </div>
    </div>`;
  el.style.display = 'block';
  document.getElementById('oph-appLayout').style.display = 'none';
}

/* Empfänger aus den Section-Einstellungen: beide Felder, Komma/Semikolon/Leerzeichen getrennt, ohne Doppelte */
function parseEmails(values){
  const out = [];
  values.join(' ').split(/[\s,;]+/).forEach(v=>{
    const e = v.trim().toLowerCase();
    if(EMAIL_RE.test(e) && !out.includes(e)) out.push(e);
  });
  return out;
}

/* ---------- Init ---------- */
function boot(){
  const el = document.getElementById('oph-root');
  if(!el || el.dataset.ophInit) return;
  el.dataset.ophInit = '1';
  root = el;
  const ds = root.dataset;
  CFG = {
    kicker: ds.kicker || '', heading: ds.heading || '', intro: ds.intro || '',
    privacyUrl: ds.privacyUrl || '', klaviyoId: ds.klaviyoId || '', notifyEmails: parseEmails([root.getAttribute('data-notify-email') || '', root.getAttribute('data-notify-email-2') || '']), sheetUrl: ds.sheetUrl || '', sheetToken: ds.sheetToken || '', logoIcon: ds.logoIcon, logoWord: ds.logoWord
  };
  CARD_BG = { b2b: ds.cardB2b, creator: ds.cardCreator, athlete: ds.cardAthlete, affiliate: ds.cardAffiliate };

  renderRouter();
}

window.OPH = { backToRouter, copySummary, downloadPDF, fixField, goToStep, handleText, handleTile, nextStep, resetAll, selectSection, submitRequest };

if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);

})();
